import { Map, Record, List } from 'immutable';

const struct = {
  id:                            undefined,
  source:                        undefined,
  scoreRating:                   undefined,
  scheduledAt:                   undefined,
  record:                        new Map(),
  responses:                     new List(),
  prompts:                       new List(),
  folder:                        new Map(),
  email:                         undefined,
  msisdn:                        undefined,
  firstName:                     undefined,
  lastName:                      undefined,
  fullName:                      undefined,
  gender:                        undefined,
  education:                     undefined,
  schoolName:                    undefined,
  graduationYear:                undefined,
  lastEmployer:                  undefined,
  yearsOfExp:                    undefined,
  profileAttributes:             new List(),
  address:                       new Map(),
  createdAt:                     undefined,
  updatedAt:                     undefined,
  deletedAt:                     undefined,
  bearerToken:                   undefined,
  callToActionCompletionMessage: undefined,
  insights:                      undefined,
};

export const TALKSCORE_CATEGORIES = Object.freeze({
  PRONUNCIATION:    'pronunciation',
  VOCAB:            'vocab',
  GRAMMAR:          'grammar',
  FLUENCY:          'fluency',
  ACTIVE_LISTENING: 'active_listening',
  COMPREHENSION:    'comprehension',
});

const OVERALL_CATEGORIES_CANDIDATE_ATTRIBUTES_MAPPING = {
  'others.talkscore_pronunciation':    TALKSCORE_CATEGORIES.PRONUNCIATION,
  'others.talkscore_vocab':            TALKSCORE_CATEGORIES.VOCAB,
  'others.talkscore_grammar':          TALKSCORE_CATEGORIES.GRAMMAR,
  'others.talkscore_fluency':          TALKSCORE_CATEGORIES.FLUENCY,
  'others.talkscore_active_listening': TALKSCORE_CATEGORIES.ACTIVE_LISTENING,
  'others.talkscore_comprehension':    TALKSCORE_CATEGORIES.COMPREHENSION,
  'others.talkscore_overall':          'overall',
  'others.talkscore_cefr':             'cefr',
};

const TALKSCORE_GENERATED_AT_ATTRIBUTE = 'others.talkscore_generated_at';

export default class CandidateApplication extends Record(struct, 'CandidateApplication') {
  getTalkScoreOverallScores() {
    const validKeys = Object.keys(OVERALL_CATEGORIES_CANDIDATE_ATTRIBUTES_MAPPING);

    const scoresList = this.profileAttributes.filter(
      (attribute) => validKeys.includes(attribute.key),
    );

    return scoresList.reduce((acc, attribute) => {
      const { key, raw: value } = attribute;
      const category = OVERALL_CATEGORIES_CANDIDATE_ATTRIBUTES_MAPPING[key];
      acc[category] = value;

      return acc;
    }, {});
  }

  getTalkScoreGeneratedAt() {
    const attribute = this.profileAttributes.find(
      (profileAttribute) => profileAttribute.key === TALKSCORE_GENERATED_AT_ATTRIBUTE,
    );

    return attribute ? new Date(attribute.value) : null;
  }

  getPromptSuggestedAnswer(promptId) {
    const normalizedSuggestions = this.insights?.get('answerSuggestions') || new Map();

    return normalizedSuggestions.get(promptId);
  }
}
